import { setDocumentTitle } from "@/lib/documentTitle";
// src/features/TptStaticData/main.tsx
import { useEffect } from "react";
import { TptStaticDataCard } from "./card";
import { TptStaticDataNew } from "./new";
import { Route, Routes } from "react-router-dom";

import { TptStaticDataTable } from "./table";

export default function TptStaticData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Données statiques TPT");
  }, []);

  return (
    <Routes>
      <Route index element={<TptStaticDataTable />} />
      <Route path="/new" element={<TptStaticDataNew />} />
      <Route path=":id" element={<TptStaticDataCard />} />
    </Routes>
  );
}
